// extracted by mini-css-extract-plugin
export default {"NewClientAdminDialog":"NewClientAdminDialog_NewClientAdminDialog__Sej6j"};